import { DebouncedFunc } from 'lodash';
import React from 'react';

import { NewTextInput } from '@/core/components/inputs/TextInput';
import { useIsLg } from '@/core/hooks/useMediaQuery';
import { useNativeContext } from '@/core/lib/native/native.context';
import { InputValidation } from '@/core/types/components';

export type InnerLocationInputProps = {
  onFocus?: ((event: React.FocusEvent<HTMLInputElement | HTMLTextAreaElement, Element>) => void) | undefined;
  onClick?: (event: React.MouseEvent<HTMLInputElement | HTMLTextAreaElement>) => void;
  placeholder?: string;
  validation?: InputValidation;
  isDisabled?: boolean;
  enterKeyHint?: 'enter' | 'done' | 'go' | 'next' | 'previous' | 'search' | 'send';
  readOnly?: boolean;
  historicalSearches?: string[];
  hideCleanIcon?: boolean;
  isOpen: boolean;
  inputPlaceholder: string;
  id: string;
  inputRef: React.RefObject<HTMLInputElement | null>;
  inputValue: string;
  onOpen: () => void;
  onSearch: DebouncedFunc<(searchVal: string) => void>;
  onClean?: () => void;
};
export const InnerLocationInput: React.FC<InnerLocationInputProps> = ({ isOpen, placeholder, inputPlaceholder, id, inputRef, inputValue, onOpen, onSearch, onClean, ...rest }) => {
  const { isNative } = useNativeContext();
  const isLg = useIsLg();

  return (
    <label htmlFor={`select-${id}`} className={isOpen && isNative && !isLg ? '[&>*:nth-child(2)]:my-4' : ''}>
      <span className="sr-only">{placeholder}</span>
      <NewTextInput
        {...rest}
        ref={inputRef}
        id={`select-${id}`}
        placeholder={inputPlaceholder}
        value={inputValue}
        onClick={!isLg && isOpen ? undefined : onOpen}
        onChange={onSearch}
        onClean={onClean}
        autoComplete="off"
      />
    </label>
  );
};
